import styled from 'styled-components';
import InlineSVG from 'svg-inline-react';
import { animated } from 'react-spring';
import { EEL, MOBILE } from '../../theme';

const ProgressBarContainer = styled.div`
  height: ${props => props.currentStep === 2 ? `auto`: `5rem`};
  width: 60%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;

  @media (max-width: ${MOBILE}) {
    width: 70%;
  }
`;

const Dot = styled(InlineSVG)`
  svg {
    height: 1.25rem;
    fill: ${props => props.current === `true` ? EEL : `black`};
    transition: 1s;
  }
`;

const DotsContainer = styled.div`
  height: 0.875rem;
  width: calc(100% + 1.25rem);
  position: absolute;
  left: -0.6rem;
  top: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: space-between
`;


const Bar = styled.div`
  height: 0.6rem;
  width: 100%;
  background: black;
  position: absolute;
  left: 0;
  top: 1.25rem;
`;

const BarFill = animated(styled(Bar)`
  background: ${EEL};
  width: 0%;
`);

const TextContainer = styled.div`
  width: calc(100% + 5rem);
  margin-top: 0;
  display: flex;
  justify-content: space-between;
`;

const Text = styled.p`
  margin: ${props => props.current === `true` ? 0.6 : -1.25}rem 0 0 0;
  color: ${props => props.current === `true` ? `white` : `gray`};
  font-size: ${props => props.current === `true` ? 1.5 : 1}rem;
  transition: 500ms ease;

  @media (max-width: ${MOBILE}) {
    font-size: ${props => props.current === `true` ? 1.125 : 0.75}rem;
  }
`;

const AnimsContainer = styled.div`
  width: calc(100% + 5rem);
  display: flex;
  justify-content: space-between;
`;

const Anim = styled.div`
  height: 5rem;
  width: 5rem;
  z-index: 10;
  opacity: ${props => props.current === `true` ? 1 : 0};
  transition: 500ms;
`;

export {
  Bar,
  ProgressBarContainer,
  BarFill,
  TextContainer,
  Text,
  Dot,
  DotsContainer,
  AnimsContainer,
  Anim,
};